<template>
    <div class="placeholder-container">
        <div class="content-wrapper">
            <!-- 머티리얼 플러그 아이콘 (뉴모피즘) -->
            <div class="icon-wrapper">
                <div class="plug-icon-container">
                    <!-- 플러그 아이콘 -->
                    <div class="plug-icon-base">
                        <img src="/assets/img/svg/img-4.svg" alt="플러그인 연결" class="plug-svg" />
                    </div>
                    
             
                </div>
            </div>
            
            <div class="message-section">
                <h1 class="main-title">{{ displayLabel }}</h1>
                <p class="sub-title">연결이 끊어졌습니다</p>
                <p class="description">플러그인 연결을 확인해주세요</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        displayLabel() {
            return this.$route.query.label || "플러그인";
        }
    },
    methods: {
    
    }
}
</script>

<style scoped>
.placeholder-container {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-top: 31px;
}

.content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.icon-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}

/* 플러그 아이콘 컨테이너 */
.plug-icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

/* 플러그 아이콘 베이스 */
.plug-icon-base {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

/* SVG 스타일 - 배경색 #D9E0E7와 어울리게 필터 적용 */
.plug-svg {
    width: 76vw;
    height: auto;
    filter: brightness(1.05) 
            saturate(0.65) 
            contrast(0.92)
            drop-shadow(-8px -8px 16px rgba(255, 255, 255, 0.7))
            drop-shadow(8px 8px 16px rgba(174, 188, 202, 0.5));
    object-fit: cover;
}



.message-section {
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;
}

.main-title {
    color: #4A5D70;
    font-size: 2.5rem;
    font-weight: 700;
    margin: 0;
    letter-spacing: -0.02em;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.sub-title {
    color: #6A7D90;
    font-size: 1.5rem;
    font-weight: 500;
    margin: 0;
    letter-spacing: -0.01em;
}

.description {
    color: #8A9DAF;
    font-size: 1.1rem;
    font-weight: 400;
    margin: 0;
    margin-top: 8px;
}

@media (max-width: 768px) {
    .main-title {
        font-size: 2rem;
    }
    
    .sub-title {
        font-size: 1.2rem;
    }
    
    .description {
        font-size: 1rem;
    }
    
    .plug-svg {
        width: 360px;
        height: auto;
        filter: brightness(1.05) 
                saturate(0.65) 
                contrast(0.92)
                drop-shadow(-6px -6px 12px rgba(255, 255, 255, 0.7))
                drop-shadow(6px 6px 12px rgba(174, 188, 202, 0.5));
    }

    
 
    
   
}
</style>
